import { DropdownOption } from "common/types";
import { State } from "common/types/redux";

import { getSoundEffectsPreferenceLevel } from "features/user/selectors";

import UserPreferences, {
  SoundEffectsPreference
} from "../models/UserPreferences";
import { getUserSlice } from "./userInfo";

export const getUserPreferences = (state: State): UserPreferences =>
  getUserSlice(state).preferences;

export const getUserHasPickedDisplayName = (state: State) =>
  getUserPreferences(state).hasPickedDisplayName;

export const getMapGradient = (state: State) =>
  getUserPreferences(state).mapGradient;

export const getTypingPreference = (state: State) =>
  getUserPreferences(state).typingPreference;

export const getModuleToolbarOpenByDefault = (state: State) =>
  getUserPreferences(state).moduleToolbarOpenByDefault;

export const getAgeGroup = (state: State) => getUserPreferences(state).ageGroup;

export const getRegion = (state: State) => getUserPreferences(state).region;

export const getAgeGroupPreferenceOption = (
  state: State
): DropdownOption<string> | null | undefined => {
  const ageGroup = getAgeGroup(state);
  return ageGroup
    ? {
        label: ageGroup,
        value: ageGroup
      }
    : null;
};

export const smartLearningIsEnabled = (state: State) =>
  getUserPreferences(state).smartLearningEnabled;

export const getNotifyWhenDataRequestReady = (state: State) =>
  getUserPreferences(state).notifyWhenDataRequestReady;

export function getLegacySoundEffectsEnabled(state: State) {
  return getUserPreferences(state).soundEffectsEnabled;
}

export function getSoundEffectsLevel(state: State) {
  return getUserPreferences(state).soundEffectsLevel;
}

// for use in existing analytics
export function getSoundEffectsEnabled(state: State) {
  const level = getSoundEffectsPreferenceLevel(state);

  return level !== SoundEffectsPreference.none;
}

export function getPreferredTheme(state: State) {
  return getUserPreferences(state).preferredTheme;
}

export function getPreferredThemeMode(state: State) {
  return getUserPreferences(state).preferredThemeMode;
}
